import {IApiContestant} from "../typings/apiResponse";
import {ContestantResource} from "../resource/ContestantResource";
import {Contestant} from "../league/Contestant";
import * as angular from "angular";

/**
 * @deprecated since only function of class is deprecated.
 */
export class ContestantService {

    public static $inject = ["$log", "ContestantResource"];
    constructor(private $log:angular.ILogService,
                private ContestantResource:ContestantResource) {
    }

    /**
     * @deprecated in favor of LeagueService::getUserContestantInfos.
     * Multiple contestants in league for user is now supported.
     */
    public getContestantInLeague(leagueId:number): angular.IPromise<Contestant> {
        return this.ContestantResource.getContestantInLeague(leagueId).then(
            (apiContestant:IApiContestant) => {
                return new Contestant(apiContestant);
            },
            (error: string) => {
                this.$log.info(error);
                return null;
            }
        );
    }
}
